import { FC } from 'react';
import { useFavoriteToggleContext } from '#baseMenu/components';
import { StateCallbacks } from '#advertFavorite/objects';

type PropsType = {
  stateCallbacks?: StateCallbacks;
};

const AdvertFavoriteBottomSheetHolder: FC<PropsType> = ({
  stateCallbacks,
}) => {
  const { AdvertFavoriteBottomSheet, isLoaded } = useFavoriteToggleContext();

  if (!isLoaded) {
    return null;
  }

  return <AdvertFavoriteBottomSheet stateCallbacks={stateCallbacks} />;
};

export { AdvertFavoriteBottomSheetHolder };
